// axios请求方法（get、post等）封装
export const get = (axios, url, params, header) => {
  return axios({ url, method: 'get', params, headers: header || {} })
}

export const post = (axios, url, data, headers = {}) => {
  return axios({ url, method: 'post', data, headers })
}
